import request from '@/utils/request'
//采集器模块

// 加载表格数据
export function getShipMethod(params) {
    return request({
      url: "/server/ship/select",
      method: "get",
      params: params,
    })
  }